module.exports = __webpack_public_path__ + "static/media/2.36cb9798.jpg";